import axios from 'axios';
import { BUSINESS_ADMIN_HOST } from 'api/constants';
import { createErrorFromAxiosMultipleErrors } from 'api/utilities';

export async function getBusinessById(businessId) {
  try {
    return await axios.get(
      `${BUSINESS_ADMIN_HOST}/v1/businesses/${businessId}`
    );
  } catch (e) {
    throw createErrorFromAxiosMultipleErrors(e);
  }
}

export async function restoreBusiness(businessId, ticketLink, notes) {
  try {
    return await axios.post(
      `${BUSINESS_ADMIN_HOST}/v1/businesses/${businessId}/restore`,
      { ticket_link: ticketLink, notes }
    );
  } catch (e) {
    throw createErrorFromAxiosMultipleErrors(e);
  }
}

export async function getRestoreDeletedBusinessLogs(page, size) {
  try {
    return await axios.get(
      `${BUSINESS_ADMIN_HOST}/v1/businesses/restore-logs`,
      { params: { page, size } }
    );
  } catch (e) {
    throw createErrorFromAxiosMultipleErrors(e);
  }
}
